import {FC, useState} from "react";
import {TeamSpaceItem} from "../../../../lib/src/api/repositories/documentation-library-repository";
import {useApiCall} from "../../../../lib/src/api";
import {config} from "../../config";
import {ModalFooter} from "../../../../lib/src/components/layout/ModalProvider";
import {Input} from "@ventumsoftware/react-toolkit";
import {useToasts} from "../../../../lib/src/toasts/toasts";

export const EditPageModal: FC<{ item: TeamSpaceItem, onFinished: () => void }> = ({ item, onFinished }) => {
  const { documentations } = useApiCall(config)
  const {showToast} = useToasts()

  const [name, setName] = useState<string>(item.name)

  const save = async () => {
    await documentations.updatePage(item.teamSpaceId, item.id, name)
      .catch(() => {
        showToast('Oeps', 'Er is iets misgegaan bij het bewerken.')
      })
    onFinished()
  }

  return <div>
    <Input type={'text'} label={'Naam'} value={name} onChange={setName} />
    <ModalFooter text={'Opslaan'} onSubmit={async () => {
      await save()
      close()
    }} />
  </div>
}